export function localDateTimeValue(date = new Date()) {
  const local = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
  return local.toISOString().slice(0, 16);
}

export function workOrderDuration(startedAt, finishedAt) {
  if (!startedAt) return ``;
  if (!finishedAt) return `En curso`;
  const start = new Date(startedAt).getTime();
  const finish = new Date(finishedAt).getTime();
  if (!Number.isFinite(start) || !Number.isFinite(finish) || finish < start) return ``;
  const minutes = Math.floor((finish - start) / 60000);
  if (minutes < 60) return `${minutes} min`;
  const hours = Math.floor(minutes / 60);
  return `${hours} h ${String(minutes % 60).padStart(2, `0`)} min`;
}

export function validWorkOrderTiming(startedAt, finishedAt) {
  return !finishedAt || (!!startedAt && new Date(finishedAt).getTime() >= new Date(startedAt).getTime());
}
